import { useTranslation } from 'react-i18next';

/**
 * Hook to translate dynamic content like specialties, modalities, and tags
 */
export function useTranslatedContent() {
  const { t, i18n } = useTranslation();

  /**
   * Translate a specialty name
   */
  const translateSpecialty = (specialty: string): string => {
    const key = `specialties.${specialty}`;
    const translation = t(key);
    // If no translation found, return original value
    return translation === key ? specialty : translation;
  };

  /**
   * Translate a modality name
   */
  const translateModality = (modality: string): string => {
    const key = `modalities.${modality}`;
    const translation = t(key);
    return translation === key ? modality : translation;
  };

  /**
   * Translate a certification name
   */
  const translateCertification = (certification: string): string => {
    const key = `certifications.${certification}`;
    const translation = t(key);
    return translation === key ? certification : translation;
  };

  /**
   * Translate a deployment option
   */
  const translateDeployment = (deployment: string): string => {
    const key = `deployment.${deployment.toLowerCase()}`;
    const translation = t(key);
    return translation === key ? deployment : translation;
  };

  /**
   * Translate an array of specialties
   */
  const translateSpecialties = (specialties: string[]): string[] => {
    return specialties.map(translateSpecialty);
  };

  /**
   * Translate an array of modalities
   */
  const translateModalities = (modalities: string[]): string[] => {
    return modalities.map(translateModality);
  };

  return {
    translateSpecialty,
    translateModality,
    translateCertification,
    translateDeployment,
    translateSpecialties,
    translateModalities,
    language: i18n.language,
  };
}
